import { render, staticRenderFns } from "./TheoryPaperDetail.vue?vue&type=template&id=7e5733b6&scoped=true&"
import script from "./TheoryPaperDetail.vue?vue&type=script&lang=js&"
export * from "./TheoryPaperDetail.vue?vue&type=script&lang=js&"
import style0 from "./TheoryPaperDetail.vue?vue&type=style&index=0&id=7e5733b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5733b6",
  null
  
)

export default component.exports